




import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import dataProxyService from '@/services/data-proxy.service';
import {KategorijaVozila} from "@/services/BackendProxies";

@Component({})
export default class KategorijeVozilaEditor extends Vue {
    kategorijeVozila = [];
    @Prop() value !: string;

    model = '';

    async created() {
        const grupe = this.kategorijeVozila = await dataProxyService.vratiKategorijeVozila();
        grupe.unshift(KategorijaVozila.fromJS({id: '', naziv: '...'}));
        this.kategorijeVozila = grupe.map(gv => ({id: gv.id, text: gv.naziv}));
        this.model = this.value;
    }

    @Watch("value") onValueChange(val) {
        this.model = val;
    }

    @Watch("model") onModelChange(val) {
        this.input(val);
    }

    @Emit() input(val) {

    }
}
